//Available labels actions
export const ADD_SUCCESS = 'add_success';
export const ADD_ERROR = 'add_error';
export const DELETE_FROM_MEDIA_SUCCESS = 'delete_from_media_success';
export const DELETE_FROM_MEDIA_ERROR = 'delete_from_media_error';
export const DELETE_SUCCESS = 'delete_success';
export const DELETE_ERROR = 'delete_error';
